import React from 'react';

import clsxm from '@/lib/clsxm';

import iconPath from '../../assets/icons.svg';

export interface IconProps {
  name: string;
  className?: string;
  height?: number;
  width?: number;
  isGrayedOut?: boolean;
}

const Icon: React.FC<IconProps> = ({
  name,
  className,
  width,
  height,
  isGrayedOut,
}) => {
  return (
    <svg
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
      className={clsxm(
        'h-full w-full fill-current stroke-current text-black',
        isGrayedOut && 'text-ds-grey-500',
        className
      )}
    >
      <use href={`${iconPath}#${name}`} />
    </svg>
  );
};

export default Icon;
